const PATCH_NOTES = [
  {
    title: `Version ${process.env.VUE_APP_VERSION}`,
    date: '2025-05-09', // '09 de Mayo de 2025',
    changes: [
      {
        title: 'Nouvelle fonctionnalité multilingue.',
        description: [
          'Les langues \'anglais\', \'français\', \'allemand\', \'catalan\', \'galicien\' et \'basque\' sont ajoutées.',
        ]
      },
      {
        title: 'Changement d\'agenda',
        description: [
          'Agenda change de nom et devient \'Sociétés\'.',
          'Les sections \'Entreprises liées\' et \'Historique\' sont ajoutées aux Entreprises.',
          'Les sections \'Courriel de contact\' et \'Comptes bancaires\' ont été ajoutées au siège.',
        ]
      },
      {
        title: 'Nouveau module d\'interface pour l\'émission de factures',
        description: [
          'Il est nécessaire d\'activer le module \'Émission de factures\' pour un fonctionnement correct.',
          'Ajout d\'une nouvelle fonctionnalité permettant d\'établir des factures étape par étape',
          'Les étapes d\'émission des factures \'Participants\', \'Détail\', \'Lignes\', \'Paiement\' et \'Pièces jointes\' sont ajoutées.',
          'Le résumé de la facture est ajouté.',
        ]
      },
      {
        title: 'Nouveau module Veri*Factu',
        description: [
          'Les enregistrements Veri*Factu sont ajoutés.',
          'Les statuts \'Correct\', \'Accepté avec des erreurs\', \'Incorrect\' et \'A notifier\' sont ajoutés.',
          'Les détails de l\'enregistrement sont ajoutés.',
        ]
      },
      {
        title: 'Correction des erreurs',
        description: [
          'Correction d\'erreurs mineures.'
        ]
      },
    ]
  },
  {
    title: 'Version 6.1.0',
    date: '2024-09-09', // '09 de Septiembre de 2024',
    changes: [
      {
        title: 'Configuration de l\'authentification AAD/SAML2',
        description: [
          'Module d\'authentification avec intégration via Azure Active Directory',
          'Module d\'authentification avec intégration via la norme SAML2',
          'Connexion dynamique basée sur le type d\'authentification de l\'utilisateur'
        ]
      },
      {
        title: 'Nouveaux modules Webhooks',
        description: [
          'Deux nouveaux modules sont ajoutés pour les événements de factures émises et reçues',
          'Une nouvelle vue de configuration Webhook est ajoutée. Intégration avec Microsoft Teams ou intégration personnalisée (Zerocoma)'
        ]
      },
      {
        title: 'Nouveau module TicketBAI-Batuz',
        description: [
          'Une section de configuration est ajoutée pour l\'intégration avec TicketBAI-Batuz.'
        ]
      },
      {
        title: 'Modification du flux « Expédition externe »',
        description: [
          'Le statut « Expédition externe » est supprimé.',
          'Les factures qui sont dans ce statut passeront au statut « Envoyées ».',
          'Les factures avec la page « Expédition externe » passent désormais par le flux de facture normal.'
        ]
      },
      {
        title: 'Suppression des actions sur les factures émises',
        description: [
          'Toutes les actions « Aller à » sont supprimées des factures au statut « Non envoyées ».'
        ]
      },
      {
        title: 'Corrections de bugs',
        description: [
          'Corrections de bugs mineurs.'
        ]
      },
    ]
  },
  {
    title: 'Version 6.0.0',
    date: '2024-09-09', // '09 de Septiembre de 2024',
    changes: [
      {
        title: 'Nouvelle fonctionnalité d\'agenda',
        description: [
          'Une section est ajoutée où vous pouvez ajouter différents types de contacts.'
        ]
      },
      {
        title: 'Nouvelle fonctionnalité de validation',
        description: [
          'Les fichiers de factures sont comparés à leurs schémas et les pièces jointes sont vérifiées avant le téléchargement de la facture.'
        ]
      },
      {
        title: 'Nouvelle fonctionnalité de modèles',
        description: [
          'Une nouvelle configuration est ajoutée avec des valeurs par défaut pour la création de nouvelles sociétés et de nouveaux groupes.'
        ]
      },
      {
        title: 'Nouveau module d\'auto-facturation',
        description: [
          'L\'option de télécharger et d\'émettre des auto-factures depuis la plateforme est ajoutée.'
        ]
      },
      {
        title: 'Nouveau module Regroupements',
        description: [
          'Une section est ajoutée pour créer des ensembles d\'entités (Entreprises, Fournisseurs ou Clients) et les utiliser ultérieurement dans les filtres et d\'autres parties de l\'application.'
        ]
      },
      {
        title: 'Nouveau module de personnalisation',
        description: [
          'Différentes options de personnalisation sont ajoutées telles que : Logos, couleurs, compte SMTP et emails personnalisés.'
        ]
      },
      {
        title: 'Nouveau module Modèle PDF',
        description: [
          'L\'option permettant de générer une facture PDF à partir de la facture est ajoutée en fonction d\'un modèle et d\'une configuration établis.'
        ]
      },
      {
        title: 'Nouveau produit d\'EdasInvoiZEFiles',
        description: [
          'L\'option de télécharger les factures avec leurs pièces jointes depuis le service EdasInvoiZEFiles est ajoutée.'
        ]
      },
      {
        title: 'Possibilité de télécharger les factures reçues',
        description: [
          'L\'option de télécharger les factures reçues manuellement est ajoutée à partir du menu "Télécharger les factures".'
        ]
      },
      {
        title: 'Réorganisation des filtres',
        description: [
          'Les filtres des sections liées aux factures sont réorganisés.'
        ]
      },
      {
        title: 'Corrections de bugs',
        description: [
          'Corrections de bugs mineurs.'
        ]
      },
    ]
  },
  {
    title: 'Version 5.2.2',
    date: '2024-03-20', // '20 de Marzo de 2024',
    changes: [
      {
        title: '45328',
        description: [
          'Certains textes dans la validation de la licence sont corrigés.'
        ]
      },
      {
        title: 'Corrections de bugs',
        description: [
          'La disparition de la colonne "Détail" des tableaux liés aux factures est corrigée.'
        ]
      },
    ]
  },
  {
    title: 'Version 5.2.1',
    date: '2024-03-18', // '18 de Marzo de 2024',
    changes: [
      {
        title: 'Mise à jour du texte',
        description: [
          'Certains textes de l\'application sont mis à jour pour une plus grande descriptivité.'
        ]
      },
      {
        title: 'Améliorations de l\'efficacité',
        description: [
          'Des améliorations sont apportées à l\'efficacité des sélecteurs au sein de l\'application.'
        ]
      },
      {
        title: 'Corrections de bugs',
        description: [
          'Corrections de bugs mineurs.'
        ]
      },
    ]
  },
  {
    title: 'Version 5.2.0',
    date: '2024-02-27', // '27 de Febrero de 2024',
    changes: [
      {
        title: 'Programmes étendus pris en charge pour l\'émission',
        description: [
          'La compatibilité et la validation d\'autres schémas en dehors de Facturae sont ajoutées.'
        ]
      },
      {
        title: 'Signature et récupération des factures pour les expéditions externes',
        description: [
          'L\'expédition externe du point de livraison général est ajoutée, utile pour signer uniquement les factures à envoyer en externe.'
        ]
      },
      {
        title: 'Nouveau Point de Livraison Générale en Catalogne (e-Fact)',
        description: [
          'Le Point de Livraison Générale e-Fact est ajouté pour l\'envoi de factures aux administrations de Catalogne qui ne sont pas membres de la FACe.',
          'Consultez les administrations participantes dans #link:eFact#.'
        ],
        links: [
          {
            tag: 'eFait',
            linkName: 'e-Fait',
            url: 'https://efact.aoc.cat/bustia/receiver/list.htm'
          }
        ]
      },
      {
        title: 'Récupération des fichiers envoyés',
        description: [
          'Si la facture à envoyer a subi une modification pour être expédiée au Point de Livraison Générale, elle sera conservée comme document lié à la facture.'
        ]
      },
      {
        title: 'Signature d\'un tiers',
        description: [
          'Toutes les factures signées via le certificat de collaborateur social verront nos données incluses en tant que tiers dans le nœud ThirdParty des Facturae.'
        ]
      },
      {
        title: 'Corrections de bugs',
        description: [
          'Erreurs liées aux transformateurs existants.',
          'Corrections de bugs mineurs.'
        ]
      },
    ]
  },
  {
    title: 'Version 5.1.0',
    date: '2024-02-06', // '06 de Febrero de 2024',
    changes: [
      {
        title: 'Nouvelles fonctionnalités',
        description: [
          'Nouvelle fonctionnalité du tableau de bord: nouvelle vue avec des informations utiles sur les factures et les licences.'
        ]
      },
      {
        title: 'Autres changements',
        description: [
          'Corrections mineures.',
        ]
      },
    ]
  },
  {
    title: 'Version 5.0.0',
    date: '2024-02-06', // '06 de Febrero de 2024',
    changes: [
      {
        title: 'Nouvelles fonctionnalités',
        description: [
          'Nouvelle fonctionnalité de distributeur: gérez plusieurs clients en tant que distributeur avec échange de licences ou provisionnement de forme libre.',
        ]
      },
    ]
  }, 
  {
    title: 'Version 4.2.0',
    date: '2023-10-30', // '30 de Octubre de 2023',
    changes: [
      {
        title: 'Nouvelles fonctionnalités',
        description: [
          'Nouvelle fonctionnalité Groupes. Les tags sont désormais des groupes, les groupes maintiennent la fonctionnalité des tags et ajoutent : la gestion des utilisateurs, la gestion étendue des factures.',
          'Mise à jour du profil utilisateur avec des informations sur les groupes auxquels ils appartiennent.',
        ]
      },
    ]
  }, 
  {
    title: 'Version 4.1.0',
    date: '2023-08-11', // '11 de Agosto de 2023',
    changes: [
      {
        title: 'Nouvelles fonctionnalités',
        description: [
          'Incorporation des récépissés de factures dans les PGE FACe et FACeB2B.',
          'Nouveaux modules disponibles à la location. Vous pouvez les vérifier dans la section des paramètres généraux.'
        ]
      },
    ]
  }, 
  {
    title: 'Version 4.0.0',
    date: '2023-05-24', // '24 de Mayo de 2023',
    changes: [
      {
        title: 'Lancement',
        description: [
          // 'Gestion et administration de...',
        ]
      },
    ]
  }, 
  // {
  //   title: 'Version 2.11.0',
  //   date: '2022-12-13', // '13 de Diciembre de 2022',
  //   changes: [
  //     {
  //       title: 'Nouvelles fonctionnalités',
  //       description: [
  //         'Nouveau type d\'utilisateur : Utilisateur de requête. Utilisateur pour la consultation et la révision des données, similaire au rôle « Utilisateur » avec des restrictions lors de l\'exécution d\'actions sur les factures, vous pouvez uniquement les visualiser et télécharger leur contenu.',
  //         'Nouvelle fonctionnalité d\'édition et de suppression de métadonnées supplémentaires d\'une facture, accessible dans les détails de la facture.',
  //         'L\'option permettant d\'exporter un fichier Excel des erreurs détectées a été ajoutée à partir de la boîte de dialogue Détails des erreurs du tableau de bord.',
  //         'Une nouvelle option a été ajoutée pour exporter un fichier Excel de l\'historique complet des erreurs détectées, pour une entreprise et un siège social spécifiques, à partir de la boîte de dialogue des détails de l\'erreur du tableau de bord.',
  //         'Lors de la sélection de l\'action "Exclure l\'organisation associée" depuis la vue facture, l\'option d\'exclure ladite organisation de toutes les entreprises du client a été ajoutée, en plus de conserver l\'option par défaut d\'exclure uniquement l\'organisation de l\'entreprise associée à cette facture.',
  //       ]
  //     },
  //     {
  //       title: 'Bogues corrigés',
  //       description: [
  //         'Erreur corrigée lors du téléchargement manuel des factures.',
  //         'Corrections dans les textes et descriptions.',
  //         'Autres correctifs mineurs',
  //       ]
  //     },
  //   ]
  // }, 
]

export {
  PATCH_NOTES
}

